<div
  class="alert fade show"
  [class.text-cam-green]="success"
  [class.text-cam-red]="error"
  role="alert"
  *ngIf="error || success"
>
  {{ error ? error : success }}
</div>
